import { esaBusManager } from '../Esa/esaBus';
import { shellEventBus } from '../../shell/events/eventBus';
import { getOrCreateAwarenessStore } from './store/canvasAwarenessStore';
import { performCapabilityTabsRefresh } from './layouts/capabilityTabsRefresh';
import { getSolutionRunStore } from './store/solutionRunStore';

/**
 * Ask the active canvas (and workspace surface) to refetch without remounting.
 * Used after HIL raise/resolve/exit so runs lists and agent-request rows stay current.
 */
export function notifyCanvasRefresh(): void {
  performCapabilityTabsRefresh(
    () => getOrCreateAwarenessStore()?.getState().viewport.surfaceId,
    (surfaceId, scope) => esaBusManager.pushRefresh(surfaceId, scope),
  );
}

function extractConverseTaskId(metadata: Record<string, unknown> | undefined): string {
  const raw = metadata?.task_id;
  return typeof raw === 'string' && raw.trim() ? raw.trim() : '';
}

/**
 * Chat plan-confirm ("harmonize" → yes) does not go through Invoke overlay or
 * ResolvingView. Refresh the runs canvas after the turn, and open the new run
 * when converse returns a task_id — unless the overlay is already initiating.
 */
export function syncCanvasAfterConverse(
  metadata?: Record<string, unknown>,
  options?: { openDispatchedRun?: boolean },
): void {
  const taskId = extractConverseTaskId(metadata);
  const overlayBusy = getSolutionRunStore().getState().status === 'initiating';
  if (options?.openDispatchedRun !== false && taskId && !overlayBusy) {
    shellEventBus.dispatch({
      type: 'SOLUTION_RUN_INITIATED',
      payload: { runId: taskId, navTarget: null },
    });
    return;
  }
  notifyCanvasRefresh();
}
